module.exports = __webpack_public_path__ + "static/media/b2_p8_clickable_b.a25ec255.png";